import { render, staticRenderFns } from "./AdUnitsSelector.vue?vue&type=template&id=2fe18342&"
import script from "./AdUnitsSelector.vue?vue&type=script&lang=ts&"
export * from "./AdUnitsSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAutocomplete,VBtn})
